<template>
    <div class="w-full aspect-square">
        <swiper-container
            class="max-w-screen w-[calc(100vw-2rem)] max-h-screen aspect-square"
            :thumbs="{ swiper: thumbsSwiper }"
            :loop="true"
        >
            <swiper-slide v-for="item in slides" :zoom="true">
                <div class="w-full aspect-square">
                    <NuxtImg
                        format="webp"
                        width="800"
                        height="800"
                        fit="inside"
                        quality="95"
                        class="w-full h-full object-contain rounded-md"
                        :src="getImageUrl(item.original_url)"
                        sizes="sm:450px lg:600px"
                        placeholder
                    />
                </div>
            </swiper-slide>
        </swiper-container>
        <div class="w-full productGalleryThumbSlider max-h-32 min-h-20">
            <swiper-container
                @swiper="setThumbsSwiper"
                :slides-per-view="4.5"
                :space-between="10"
                :centered-slides="true"
                :centered-slides-bounds="true"
                :center-insufficient-slides="true"
                class="w-full"
            >
                <swiper-slide v-for="item in slides" class="border rounded">
                    <div class="bg-white rounded aspect-square p-2">
                        <NuxtImg
                            preset="thumbnail"
                            class="w-full h-full object-contain rounded-md"
                            :src="getImageUrl(item.original_url)"
                            sizes="50px sm:120px lg:160px"
                        />
                    </div>
                </swiper-slide>
            </swiper-container>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { IMedia } from "~/libs/types/api/media";

const props = defineProps({
    slides: {
        type: Array as PropType<IMedia[]>,
        required: true,
    },
});

const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper: any) => {
    thumbsSwiper.value = swiper;
};
</script>

<style scoped>
.productGalleryThumbSlider :deep(.swiper-slide:not(.swiper-slide-thumb-active)) {
    @apply opacity-75 border-amazon-300;
}
.productGalleryThumbSlider :deep(.swiper-slide.swiper-slide-thumb-active) {
    @apply border-2 opacity-100 border-amazon-600;
}
</style>
